const s = {
  name: "CanadianDollar",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.5,17c0-1.7,1.3-3,3-3s3,1.3,3,3v1h-2v-1c0-0.5-0.5-1-1-1c-0.5,0-1,0.5-1,1v6c0,0.5,0.5,1,1,1
			c0.5,0,1-0.5,1-1v-1h2v1c0,1.7-1.3,3-3,3s-3-1.3-3-3V17z"/>
		<path class="st0" d="M22.5,17c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v1h2v-1c0-1.3-0.8-2.4-2-2.8V13h-2v1.2c-1.2,0.4-2,1.5-2,2.8v0.8
			c0,1.1,0.6,2.2,1.7,2.7l1.8,0.9c0.3,0.2,0.6,0.5,0.6,0.9V23c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-1h-2v1c0,1.3,0.8,2.4,2,2.8V27h2
			v-1.2c1.2-0.4,2-1.5,2-2.8v-0.8c0-1.1-0.6-2.2-1.7-2.7l-1.8-0.9c-0.3-0.2-0.6-0.5-0.6-0.9V17z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CanadianDollar
};
